export default "https://cdn-static.gokick.com/assets/ac547ee441cd23ce845c1e2810a666ddd08d044b/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";